// Dependencias de terceiros (node_modules) empacotadas pelo esbuild.
// Substitui os antigos //= require do Sprockets. A ordem dos imports importa:
// jquery-global precisa vir primeiro (define window.jQuery).

// 1) jQuery global
import "./jquery-global.js";

// 2) rails-ujs para jQuery (data-method / data-confirm em links e botoes)
import "jquery-ujs/src/rails.js";

// 3) Bootstrap 5 (inclui Popper). Exposto p/ uso de bootstrap.Tooltip/Tab etc.
import * as bootstrapBundle from "bootstrap/dist/js/bootstrap.bundle.min.js";

// 4) Plugins jQuery (anexam-se ao $ global via UMD)
// select2 precisa ser instalado explicitamente (ver select2-global.js) antes do i18n.
import "./select2-global.js";
import "select2/dist/js/i18n/pt-BR.js";
import "jquery-mask-plugin/dist/jquery.mask.min.js";
import "bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js";
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.pt-BR.min.js";
import "inputmask/dist/jquery.inputmask.js";
import "jquery-maskmoney/dist/jquery.maskMoney.min.js";
import "jquery-validation/dist/jquery.validate.min.js";
import "jquery-validation/dist/additional-methods.min.js";
import "jquery-validation/dist/localization/messages_pt_BR.js";

// 5) Bibliotecas com API propria
import flatpickr from "flatpickr";
import * as flatpickrPt from "flatpickr/dist/l10n/pt.js";
import moment from "moment";
import "moment/locale/pt-br.js";
import feather from "feather-icons";
import Swiper from "swiper/bundle";
import { tns } from "tiny-slider/src/tiny-slider.js";
import * as ActionCable from "@rails/actioncable";

// --- Exposicao global (executa apos todos os imports acima) ---
window.bootstrap = bootstrapBundle.default || bootstrapBundle;

const Portuguese = flatpickrPt.Portuguese || flatpickrPt.default || flatpickrPt;
if (Portuguese && flatpickr.l10ns) {
  flatpickr.l10ns.pt = Portuguese;
  flatpickr.localize(Portuguese);
}
window.flatpickr = flatpickr;

moment.locale("pt-br");
window.moment = moment;
window.feather = feather.default || feather;
window.Swiper = Swiper.default || Swiper;
window.tns = tns;

window.ActionCable = ActionCable;
window.App = window.App || {};


import "./src/models/animals/usage_other_controller.js";

import "./src/models/customers.js";

import "./src/models/proposals.js";

import "./src/models/proposals/coverages.js";

import "./src/models/proposals/issue_policy.js";
